import React, { useEffect, useState } from "react";
import Timeline from "../Timeline/Membertimelne";
import AlbumsCard from "../../Gallary/Albums/AlbumsCards";
import PhotosCard from "../../Gallary/photos/Photo";
import VideosCard from "../../Gallary/Videos/video";
import ProfileBanner from "./ProfileBanner";
import LeftSidebar from "./LeftSidebar";
import { ProfileGet } from "../../apis/api/ProfileApi";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import Lodderr from "../../components/Lodder/Lodder";
import { albumGet } from "../../apis/api/GalleryApis";

const Profile = () => {
  const dispatch = useDispatch();

  const [memberData, setmemberData] = useState([]);
  const userId = Cookies.get("userID");
  const company_id = Cookies.get("company_id");
  const access = JSON.parse(Cookies.get("access"));

  const profileData = useSelector((state) => state.ProfileSlice.profileData);
  const album = useSelector((state) => state.GallerySlice.album);
  const loading = useSelector((state) => state.ProfileSlice.loading);

  useEffect(() => {
    (async () => {
      try {
        await dispatch(ProfileGet({ userId, company_id }));
        await dispatch(albumGet({ company_id }));
      } catch (error) {
        console.error("Error:", error);
      }
    })();
  }, []);

  useEffect(() => {
    if (profileData?.data) {
      setmemberData(profileData.data);
    }
    console.log("Profile: ", profileData?.data)
  }, [profileData]);

  const [activeTab, setActiveTab] = useState("about");

  return (
    <>
      {loading && <Lodderr />}
      <div className="">
        {memberData ? (
          <ProfileBanner profiledata={memberData} />
        ) : (
          <p>Loading...</p>
        )}
        <ul className="nav nav-tabs mt-3">
          <li className="nav-item">
            <button
              className={`nav-link ${activeTab === "about" ? "active" : ""}`}
              onClick={() => setActiveTab("about")}
            >
              About
            </button>
          </li>
          {
            (access.gallery_access && access.gallery_access==="1") && 
            (
              <>
              <li className="nav-item">
                <button
                  className={`nav-link ${activeTab === "Albums" ? "active" : ""}`}
                  onClick={() => setActiveTab("Albums")}
                >
                  Albums
                </button>
              </li>
              <li className="nav-item">
                <button
                  className={`nav-link ${activeTab === "Photos" ? "active" : ""}`}
                  onClick={() => setActiveTab("Photos")}
                >
                  Photos
                </button>
              </li>
              <li className="nav-item">
                <button
                  className={`nav-link ${activeTab === "videos" ? "active" : ""}`}
                  onClick={() => setActiveTab("videos")}
                >
                  Videos
                </button>
              </li>
              </>
            )
          }
        </ul>

        <div className="mt-3">
          {activeTab === "about" && (
            <div className="row mt-4">
              <LeftSidebar profileData={profileData} />
              <div className="col-md-6 fixed-column">
                <div className="col-12">
                  <Timeline />
                </div>
              </div>
            </div>
          )}

          
          {activeTab === "Albums" && (
            <div className="mt-5">
              <AlbumsCard />
            </div>
          )}

          {activeTab === "Photos" && (
            <div>
              <PhotosCard />
            </div>
          )}

          {activeTab === "videos" && (
            <div>
              <VideosCard />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Profile;
